import request from '@/utils/request';

export default {
    getOptions: async({ dispatch, commit }, params) => {
        await request({ method: 'get', url: '/admin/options', params })
            .then(res => {
                if (res.data) {
                    commit('PROCCESS_RES', Object.assign({}, res.data, { type: 'tariffs' }));
                }
            }).catch(error => {
                if(error.response && error.response.data && error.response.data.error) {
                    dispatch('alert/addMessage', {
                        message: error.response.data.error
                    }, { root: true });
                }
            });
    },

    getCommissions: async({ dispatch, commit }, params) => {
        await request({ method: 'get', url: '/admin/driver/commissions', params })
            .then(res => {
                if (res.data) {
                    commit('PROCCESS_RES', Object.assign({}, res.data, { type: 'commissions' }));
                }
            }).catch(error => {
                if(error.response && error.response.data && error.response.data.error) {
                    dispatch('alert/addMessage', {
                        message: error.response.data.error
                    }, { root: true });
                }
            });
    },

    getCommissionSystems: async({ dispatch, commit }, params) => {
        await request({ method: 'get', url: '/commission-systems', params })
            .then(res => {
                if (res.data) {
                    commit('PROCCESS_RES', Object.assign({}, res.data, { type: 'commissionSystems' }));
                }
            }).catch(error => {
                if(error.response && error.response.data && error.response.data.error) {
                    dispatch('alert/addMessage', {
                        message: error.response.data.error
                    }, { root: true });
                }
            });
    },

    getPenalties: async({ dispatch, commit }, params) => {
        await request({ method: 'get', url: '/admin/driver/penalties', params })
            .then(res => {
                if (res.data) {
                    commit('PROCCESS_RES', Object.assign({}, res.data, { type: 'penalties' }));
                }
            }).catch(error => {
                if(error.response && error.response.data && error.response.data.error) {
                    dispatch('alert/addMessage', {
                        message: error.response.data.error
                    }, { root: true });
                }
            });
    },

    duplicateOption: ({ dispatch, commit }, data) => {
        const { optionId, brandId, newBrandId } = data;

        request({
            url: `/admin/options/${optionId}/${newBrandId}/duplicate`,
            method: 'post'
        }).then(response => {
            const { data, status } = response;

            if (data && status === 201) {
                if (brandId == newBrandId) {
                    commit('ADD_OPTION', {
                        optionId,
                        ...data
                    });
                }

                dispatch('alert/addMessage', {
                    type: 'success',
                    message: 'success'
                }, { root: true });
            }
        }).catch(error => {
            const message = error.response && error.response.data && error.response.data.error;

            if (message) {
                dispatch('alert/addMessage', {
                    type: 'error',
                    message
                }, { root: true });
            }
        });
    }
};
